<template>
    <b-menu-dropdown
        ref="menu_dropdown"
        @toggle="handleMenuToggle"
        :active="is_menu_active"
        :class="['slack-menu', { 'slack-menu-active': is_menu_active }]"
    >
        <template v-slot:trigger>Slack</template>
        <div class="slack-menu-ctn p-channel_sidebar p-channel_sidebar--iap1">
            <div
                class="p-channel_sidebar__static_list__item p-channel_sidebar__static_list__item--contain c-virtual_list__item"
                tabindex="-1"
                role="treeitem"
                @click="$router.push({name: 'slack.saveditems' })"
            >
                <div class="">
                    <div :class="`${$route.name === 'slack.saveditems' ? 'p-channel_sidebar__link--selected' : ''} p-channel_sidebar__link p-channel_sidebar__link--page p-channel_sidebar__link--page_psaved position_relative`"><i
                            class="c-icon p-channel_sidebar__link__icon c-icon--bookmark c-icon--inherit"
                            type="bookmark"
                            aria-hidden="true"
                        ></i><span
                            class="p-channel_sidebar__name"
                            data-qa="channel_sidebar_name_page_psaved"
                        >Saved items</span></div>
                </div>
            </div>
            <channels-list
                :channels="channels"
                :selected_item="selected_item"
                @onselected="selected_item = $event"
                @onSaved="init()"
                :key="channels.length"
            />
            <direct-messages-list
                :channels="ims"
                :selected_item="selected_item"
                @onselected="selected_item = $event"
            />
        </div>
    </b-menu-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { list_channels, } from "../../slack_api"
import { ChannelsList, DirectMessagesList } from '.'
export default {
    components: {
        ChannelsList,
        DirectMessagesList,
    },
    computed: {
        ...mapGetters([
            'slack_is_signed_in',
        ]),
        is_menu_active() {
            return /^slack(?:\.[a-z\.]*)?$/g.test(this.$route.name)
        },
    },
    data() {
        return {
            channels: [],
            ims: [],
            is_channels_menu_active: false,
            selected_item: null,
        }
    },
    methods: {
        ...mapActions(['closeSidebar']),
        handleSlackLabelMenu(item, e) {
            this.$router.push({ name: 'slack.channel', params: { id: item.id } })
        },
        handleMenuToggle(isActive) {
            !this.is_menu_active && isActive && this.$router.push({ name: 'slack', params: {} })
        },
        init() {
            if (!this.slack_is_signed_in) {
                return
            }
            list_channels().then(({ channels, ims }) => {
                this.channels = channels
                this.ims = ims
                this.$forceUpdate()
            })
        },
        is_channel_selected(item) {
            return (this.selected_item && this.selected_item.id === item.id)
        },
        should_show_channel(item) {
            return this.is_channels_menu_active || this.is_channel_selected(item)
        },
    },
    mounted() {
        this.init()
    },
    watch: {
        slack_is_signed_in(value) {
            if (value) {
                this.init()
            }
        },
        $route(to, from) {
            if (to.name !== 'slack.channel') {
                this.selected_item = null
            }
            if (this.$refs.menu_dropdown) {
                this.$refs.menu_dropdown.isActive = /^slack(?:\.[a-z\.]*)?$/g.test(to.name)
            }
        },
    },
}
</script>
<style>
.sidebar > .menu > .o-menu-list > .menu-list > li.slack-menu.slack-menu-active > a {
  padding: 1.063rem 1rem; }

.slack-menu > a {
  padding: 1.063rem 1rem; }

.slack-menu .slack-menu-ctn {
  padding: 8px 0; }
.slack-menu .slack-menu-ctn .slack-menu-item {
  margin-top: 2px; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn {
  color: rgba(255, 255, 255, 0.5);
  align-items: center;
  border-radius: 0 16px 16px 0;
  display: flex;
  height: 32px;
  padding: 0 12px 0 21px;
  transition: margin 0.15s cubic-bezier(0.4, 0, 0.2, 1), padding 0.15s cubic-bezier(0.4, 0, 0.2, 1); }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn.is-active {
  background-color: #019ae0;
  color: white; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn.is-active .slack-menu-icon {
  opacity: 1; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn.is-active .slack-menu-item-text, .slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn.is-active .badge {
  padding-top: 2px; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn .slack-menu-icon {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 20px;
  justify-content: flex-start;
  margin-right: 6px;
  opacity: 0.54;
  width: 20px; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn .slack-menu-icon:before {
  content: '';
  background-image: var(--bg-image);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
  display: block;
  height: 20px;
  width: 20px; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn .slack-menu-item-txt-ctn {
  line-height: 20px;
  overflow: hidden;
  padding-right: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn .slack-menu-item-txt-ctn .slack-menu-item-text {
  display: inline-block;
  max-width: 75%;
  overflow: hidden;
  padding-left: 6px;
  text-overflow: ellipsis; }
.slack-menu .slack-menu-ctn .slack-menu-item .slack-item-ctn .slack-menu-item-txt-ctn .badge {
  display: block;
  font-size: .75rem;
  font-weight: 700;
  letter-spacing: .3px;
  line-height: 21px;
  text-shadow: none; }
.slack-menu .slack-menu-ctn .slack-channels-heading {
  align-items: center;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  height: 36px;
  line-height: 26px;
  padding: 0 12px 0 10px;
  width: 100%;
  user-select: none; }
.slack-menu .slack-menu-ctn .slack-channels-heading .slack-channels-expand-container {
  align-items: center;
  border-radius: 4px;
  display: flex;
  height: 26px;
  margin: 0 4px 0 0px;
  width: 26px; }
.slack-menu .slack-menu-ctn .slack-channels-heading .slack-channels-expand-container:hover {
  background: rgba(255, 255, 255, 0.1); }
.slack-menu .slack-menu-ctn .slack-channels-heading .slack-heading-right, .slack-menu .slack-menu-ctn .slack-channels-heading .p-channel_sidebar__section_heading_right {
  display: flex;
  align-items: center;
  margin-left: auto; }

</style>